import { render, staticRenderFns } from "./CounterUpPage.vue?vue&type=template&id=93eb0878&"
import script from "./CounterUpPage.vue?vue&type=script&lang=js&"
export * from "./CounterUpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports